(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2082],{

/***/ 4830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/login",
      function () {
        return __webpack_require__(26082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36822);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28821);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_8__);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  clip: rect(1px, 1px, 1px, 1px);\n  -webkit-clip-path: inset(0px 0px 99.9% 99.9%);\n  clip-path: inset(0px 0px 99.9% 99.9%);\n  overflow: hidden;\n  height: 1px;\n  width: 1px;\n  padding: 0;\n  border: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






// @mui




var StyledVisuallyHiddenHeading = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-51b00f93-0"
})(_templateObject());
var Page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var children = _param.children, pageTitle = _param.title, pageDescription = _param.description, _metadataItems = _param.metadataItems, metadataItems = _metadataItems === void 0 ? [] : _metadataItems, openGraphImage = _param.openGraphImage, jsonLd = _param.jsonLd, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "children",
        "title",
        "description",
        "metadataItems",
        "openGraphImage",
        "jsonLd"
    ]);
    var _$ref, _$ref1, _$ref2, _$ref3;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var _$ref4 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), rootTitle = _$ref4.title, rootDescription = _$ref4.description, logo = _$ref4.logo, seoMetadataItemsCollection = _$ref4.seoMetadataItemsCollection, companyFavicon = _$ref4.companyFavicon;
    var customTitle = (_$ref = lodash_find__WEBPACK_IMPORTED_MODULE_7___default()(metadataItems, {
        name: "title"
    })) === null || _$ref === void 0 ? void 0 : _$ref.content;
    var customDescription = (_$ref1 = lodash_find__WEBPACK_IMPORTED_MODULE_7___default()(metadataItems, {
        name: "description"
    })) === null || _$ref1 === void 0 ? void 0 : _$ref1.content;
    var title = ((_$ref2 = customTitle || pageTitle) === null || _$ref2 === void 0 ? void 0 : _$ref2.trim()) || rootTitle;
    var description = ((_$ref3 = customDescription || pageDescription) === null || _$ref3 === void 0 ? void 0 : _$ref3.trim()) || rootDescription;
    var openGraphItems = [
        {
            name: "og:type",
            content: "website"
        },
        {
            name: "og:url",
            content:  true ? window.location.href : 0
        },
        {
            name: "og:title",
            content: title
        },
        {
            name: "og:description",
            content: description
        },
        {
            name: "og:locale",
            content: locale
        },
        {
            name: "og:image",
            content: (openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage.url) || logo
        },
        {
            name: "og:image:alt",
            content: openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage.alt
        },
        {
            name: "twitter:title",
            content: title
        },
        {
            name: "twitter:description",
            content: description
        },
        {
            name: "twitter:image:src",
            content: (openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage.url) || logo
        }, 
    ].filter(function(item) {
        return item.content;
    });
    var _$ref5, _content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    lodash_merge__WEBPACK_IMPORTED_MODULE_8___default()(openGraphItems, (_$ref5 = seoMetadataItemsCollection === null || seoMetadataItemsCollection === void 0 ? void 0 : seoMetadataItemsCollection.items) !== null && _$ref5 !== void 0 ? _$ref5 : [], metadataItems).filter(function(item) {
                        return item.name !== "title" && item.name !== "description";
                    }).map(function(metadataItem) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                            name: metadataItem.name,
                            content: (_content = metadataItem.content) !== null && _content !== void 0 ? _content : ""
                        }, metadataItem.name);
                    }),
                    companyFavicon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                                rel: "apple-touch-icon",
                                sizes: "180x180",
                                href: companyFavicon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                                rel: "icon",
                                type: "image/png",
                                sizes: "32x32",
                                href: companyFavicon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                                rel: "icon",
                                type: "image/png",
                                sizes: "16x16",
                                href: companyFavicon
                            })
                        ]
                    })
                ]
            }),
            jsonLd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "json-ld-script",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonLd)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                ref: ref
            }, other), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledVisuallyHiddenHeading, {
                        children: title
                    }),
                    children
                ]
            }))
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 26082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ LoginPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _layouts_main__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89809);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29430);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78470);
/* harmony import */ var _components_LoadingScreen__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12030);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83321);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96259);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61582);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Layout = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a48eab9e-0"
})(_templateObject());
var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a48eab9e-1"
})(_templateObject1());
LoginPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layouts_main__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Layout, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
                children: page
            })
        })
    });
};
var __N_SSG = true;
function LoginPage(param) {
    var globalSetting = param.globalSetting;
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), user = ref.user, error = ref.error, isLoading = ref.isLoading, logout = ref.logout, login = ref.login;
    var ref1;
    var companyColor = (ref1 = globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.companyColor) !== null && ref1 !== void 0 ? ref1 : undefined;
    if (isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingScreen__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        companyColor: companyColor
    });
    if (error) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: error.message
    });
    if (user) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    children: [
                        "Welcome ",
                        user.name,
                        "!"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    variant: "text",
                    onClick: logout,
                    children: "Logout"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        title: "AI Writer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            variant: "text",
            onClick: function() {
                return login({
                    returnTo: _routes_paths__WEBPACK_IMPORTED_MODULE_6__/* .PATH_APP_SERVICES.root */ .lO.root
                });
            },
            children: "Login"
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,8424,6755,9774,2888,179], function() { return __webpack_exec__(4830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);